import { PassOfferSummary, PassTargetType } from '../models/Pass';

export type PassDuplicateLocationState = {
  duplicateFrom: PassOfferSummary;
};

/** Create-pass prefill when starting from a host lesson or space view. */
export type PassCreateFromLessonLocationState = {
  prefillTarget?: {
    targetType: PassTargetType;
    targetIds: string[];
    currencyCode?: string;
  };
  returnToLessonOptionId?: string;
  returnToSpaceId?: string;
};

export type PassFormLocationState = PassDuplicateLocationState & PassCreateFromLessonLocationState;

/** Builds a unique copy title against existing offers (case-insensitive). */
export const nextPassCopyTitle = (baseTitle: string, existing: PassOfferSummary[]): string => {
  const used = new Set(existing.map((offer) => offer.title.trim().toLocaleLowerCase()));
  const base = baseTitle.trim() || 'Pass';
  let candidate = `${base} (copy)`;
  let index = 2;
  while (used.has(candidate.toLocaleLowerCase())) {
    candidate = `${base} (copy ${index})`;
    index += 1;
  }
  return candidate;
};
